import { BuyGiftCardStateEnum } from "../enums/BuyGiftCardStateEnum";
import { BuyGiftCardSubpageEnum } from "../enums/BuyGiftCardSubpageEnum";
import { ChooseCardSubpageModel, IChooseCardSubpageModel } from "./choose-card/ChooseCardSubpage.model";
import { CustomiseCardSubpageModel, ICustomiseCardSubpageModel } from "./customise-card/CustomiseCardSubpage.model";
import { IReviewAndPaySubpageModel, ReviewAndPaySubpageModel } from "./review-pay/ReviewAndPaySubpage.model";

export interface IBuyGiftCardModel {
    id: string;

    currentSubpage: BuyGiftCardSubpageEnum;
    currentState: BuyGiftCardStateEnum;

    chooseCardSubpage: IChooseCardSubpageModel;
    customiseCardSubpage: ICustomiseCardSubpageModel;
    reviewAndPaySubpage: IReviewAndPaySubpageModel;
}

export class BuyGiftCardModel implements IBuyGiftCardModel {
    id = "";

    currentSubpage: BuyGiftCardSubpageEnum = BuyGiftCardSubpageEnum.CHOOSE_CARD;
    currentState: BuyGiftCardStateEnum = BuyGiftCardStateEnum.CHOOSE_CARD_DETAILS;

    chooseCardSubpage: IChooseCardSubpageModel;
    customiseCardSubpage: ICustomiseCardSubpageModel;
    reviewAndPaySubpage: IReviewAndPaySubpageModel;

    constructor() {
        this.id = "";
        this.currentSubpage = BuyGiftCardSubpageEnum.CHOOSE_CARD;
        this.currentState = BuyGiftCardStateEnum.CHOOSE_CARD_DETAILS;

        this.chooseCardSubpage = new ChooseCardSubpageModel();
        this.customiseCardSubpage = new CustomiseCardSubpageModel();
        this.reviewAndPaySubpage = new ReviewAndPaySubpageModel();
    }
    
    static isValid(model: IBuyGiftCardModel): boolean {
        return ChooseCardSubpageModel.isValid(model.chooseCardSubpage) &&
            CustomiseCardSubpageModel.isValid(model.customiseCardSubpage) &&
            ReviewAndPaySubpageModel.isValid(model.reviewAndPaySubpage);
    }

    static MapModel(mapFrom: IBuyGiftCardModel): IBuyGiftCardModel {
        const mapTo = new BuyGiftCardModel();

        mapTo.id = mapFrom.id;
        mapTo.currentSubpage = mapFrom.currentSubpage ?? BuyGiftCardSubpageEnum.CHOOSE_CARD;
        mapTo.currentState = mapFrom.currentState ?? BuyGiftCardStateEnum.CHOOSE_CARD_DETAILS;

        // ChooseCard subpage
        mapTo.chooseCardSubpage.chooseCardDetails.quantity = mapFrom.chooseCardSubpage.chooseCardDetails.quantity;
        mapTo.chooseCardSubpage.chooseCardDetails.value = mapFrom.chooseCardSubpage.chooseCardDetails.value;

        mapTo.chooseCardSubpage.chooseRecipients.sendIndividually = mapFrom.chooseCardSubpage.chooseRecipients.sendIndividually;
        mapTo.chooseCardSubpage.chooseRecipients.sendBy = mapFrom.chooseCardSubpage.chooseRecipients.sendBy;
        mapTo.chooseCardSubpage.chooseRecipients.recipients = [...mapFrom.chooseCardSubpage.chooseRecipients.recipients];

        mapTo.chooseCardSubpage.chooseSender.fullName = mapFrom.chooseCardSubpage.chooseSender.fullName.trim();

        // CustomiseCard subpage
        mapTo.customiseCardSubpage.customiseCard.giftCardUrl = mapFrom.customiseCardSubpage.customiseCard.giftCardUrl;
        mapTo.customiseCardSubpage.customiseCard.useCardTemplate = mapFrom.customiseCardSubpage.customiseCard.useCardTemplate ?? true;

        mapTo.customiseCardSubpage.customiseMail.personalMessage = mapFrom.customiseCardSubpage.customiseMail.personalMessage;
        mapTo.customiseCardSubpage.customiseMail.mediaUrl = mapFrom.customiseCardSubpage.customiseMail.mediaUrl;

        // ReviewAndPay subpage
        mapTo.reviewAndPaySubpage.reviewAndPaySenderInfo.useBusinessDetails = mapFrom.reviewAndPaySubpage.reviewAndPaySenderInfo.useBusinessDetails;
        mapTo.reviewAndPaySubpage.reviewAndPaySenderInfo.usePersonalDetails = mapFrom.reviewAndPaySubpage.reviewAndPaySenderInfo.usePersonalDetails;
        mapTo.reviewAndPaySubpage.reviewAndPaySenderInfo.personDetails = mapFrom.reviewAndPaySubpage.reviewAndPaySenderInfo.personDetails;
        mapTo.reviewAndPaySubpage.reviewAndPaySenderInfo.businessDetails = mapFrom.reviewAndPaySubpage.reviewAndPaySenderInfo.businessDetails;

        mapTo.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails = { ...mapFrom.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails };

        if (mapFrom.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.date != null) {
            const timestamp = Date.parse(mapFrom.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.date.toString());
            mapTo.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.date = new Date(timestamp);
        }

        mapTo.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.hour = mapFrom.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.hour;
        mapTo.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.minute = mapFrom.reviewAndPaySubpage.reviewAndPayWhenToSend.scheduleSendDetails.minute;

        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentType = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentType;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.checkoutKey = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.checkoutKey;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.checkoutExpiry = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.checkoutExpiry;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.cardAmount = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.cardAmount;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.totalAmount = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.totalAmount;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.totalFees = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.totalFees;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.currency = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.paymentDetails.currency;
        mapTo.reviewAndPaySubpage.reviewAndPayPayment.invoiceDetails = mapFrom.reviewAndPaySubpage.reviewAndPayPayment.invoiceDetails;

        return mapTo;
    }
}